import React, { memo, useState } from 'react';
import { PageHeading } from 'web-ui-components/lib/typography/headings';
import { WebsiteLink } from 'web-ui-components/lib/actions/links';
import { BulletList } from 'web-ui-components/lib/typography/lists';
import { Form } from 'react-final-form';
import PropTypes from '../../types';
import { Content } from '../../infrastructure/content';
import Download from './components/Download';
import Terms from './components/Terms';
import Submit from '../../components/Submit';

const PersonalInformationPage = memo(function PersonalInformationPage({
  savePersonalInformationForm,
  getBusinessData,
  pdfRef,
  isTermsChecked,
  onConfirmationCheckboxChange
}) {
  const [isFormSubmitted, submitForm] = useState(false);
  return (
    <Form
      onSubmit={values => {
        savePersonalInformationForm(values);
        submitForm(!isTermsChecked);
      }}
      initialValues={getBusinessData}
      render={({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <Content>
            {({
              personalInformationPageTitle = '',
              personalInformationContent1,
              personalInformationContent2,
              personalInformationContent2VMLink,
              personalInformationContent2VMContent,
              personalInformationContent3,
              personalInformationContent4a,
              personalInformationContent4UrlPre,
              personalInformationContent4UrlTitle,
              personalInformationContent4b,
              personalInformationContent5
            }) => (
              <div>
                <PageHeading>{personalInformationPageTitle}</PageHeading>
                <BulletList
                  items={[
                    personalInformationContent1,
                    <>
                      {personalInformationContent2}
                      <WebsiteLink
                        willOpenNewWindow
                        linkText={personalInformationContent2VMContent}
                        url={personalInformationContent2VMLink}
                      />
                    </>,
                    personalInformationContent3
                  ]}
                />

                <p>
                  {personalInformationContent4a}
                  <WebsiteLink
                    willOpenNewWindow
                    linkText={personalInformationContent4UrlTitle}
                    url={`${personalInformationContent4UrlPre}`}
                  />
                  {personalInformationContent4b}
                </p>
                <p>{personalInformationContent5}</p>
                <Download pdfRef={pdfRef} />
                <Terms
                  isTermsChecked={isTermsChecked}
                  onConfirmationCheckboxChange={onConfirmationCheckboxChange}
                  isFormSubmitted={isFormSubmitted}
                />
                <Submit />
              </div>
            )}
          </Content>
        </form>
      )}
    />
  );
});

PersonalInformationPage.propTypes = {
  bankId: PropTypes.bankId.isRequired,
  savePersonalInformationForm: PropTypes.func.isRequired
};

export default PersonalInformationPage;
